<script setup lang="ts">
import { AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion'
import { defaultGraphQLClient } from '@/composables/default-urql-client'
import { TicketType } from '@/lib/types'
import gql from 'graphql-tag'
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router'

const props = defineProps<{
    active: boolean
}>()
const loading = ref(false)
const currentRoute = useRoute()
const types = ref<TicketType[]>([])

watch(
    () => props.active,
    async () => {
        if (props.active) {
            await init()
        }
    }
)

async function init() {
    try {
        loading.value = true
        const {
            data: { articleTypes },
        } = await defaultGraphQLClient.query(
            gql`
                query {
                    articleTypes {
                        id
                        title
                    }
                }
            `,
            {
                sort: [
                    {
                        column: 'title',
                        direction: 'asc',
                    },
                ],
            }
        )

        types.value = articleTypes
    } finally {
        loading.value = false
    }
}
</script>

<template>
    <AccordionItem value="articles" class="border-b-0">
        <AccordionTrigger
            class="py-2 px-4 text-white hover:no-underline hover:bg-neutral-600/50 data-[state=open]:bg-zinc-800"
        >
            <div class="flex items-center">
                <div class="w-6">
                    <FontAwesomeIcon :icon="['fal', 'newspaper']" class="size-4!" />
                </div>
                <div class="ml-3 text-xs">Articles</div>
            </div>
        </AccordionTrigger>
        <AccordionContent class="pb-0 text-xs">
            <div class="flex flex-col text-white">
                <router-link v-slot="{ route, href, navigate }" to="/articles?title=All" custom>
                    <a
                        :href="href"
                        class="pl-[52px] py-2 hover:bg-neutral-600/50"
                        :class="
                            currentRoute.query.type_title === route.query.type_title
                                ? 'bg-neutral-400/25'
                                : ''
                        "
                        @click="navigate"
                        >All</a
                    >
                </router-link>
                <template v-for="item in types" :key="item.id">
                    <RouterLink
                        v-slot="{ route, href, navigate }"
                        :to="{
                            name: 'articles.index',
                            query: {
                                type_id: item.id,
                                type_title: item.title,
                            },
                        }"
                        custom
                        ><a
                            :href="href"
                            class="pl-[52px] py-2 pr-4 hover:bg-neutral-600/50 truncate"
                            :class="
                                currentRoute.query.type_title === route.query.type_title
                                    ? 'bg-neutral-400/25'
                                    : ''
                            "
                            @click="navigate"
                            >{{ item.title }}</a
                        ></RouterLink
                    >
                </template>
                <!-- <RouterLink to="/articles/templates" class="pl-[52px] py-2 hover:bg-neutral-600/50"
                    >Templates</RouterLink
                > -->
            </div>
        </AccordionContent>
    </AccordionItem>
</template>

<style scoped>
.router-link-exact-active {
    background-color: rgba(255, 255, 255, 0.1);
}
</style>
